import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./AboutADMKSection.css";

const AboutADMKSection = () => {

  const { t } = useTranslation();

  const paragraphs = [
    t("admk_para_1"),
    t("admk_para_2"),
    t("admk_para_3"),
    t("admk_para_4"),
    t("admk_para_5"),
    t("admk_para_6"),
    t("admk_para_7"),
    t("admk_para_8"),
    t("admk_para_9"),
    t("admk_para_10"),
    t("admk_para_11"),
    t("admk_para_12"),
    t("admk_para_13"),
    t("admk_para_14"),
    t("admk_para_15"),
    t("admk_para_16"),
    t("admk_para_17"),
    t("admk_para_18")
  ];

  const [visibleIndex, setVisibleIndex] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    const onScroll = () => {
      if (!section) return;

      const rect = section.getBoundingClientRect();
      const progress = Math.min(
        Math.max((window.innerHeight - rect.top) / rect.height, 0),
        1
      );

      const newIndex = Math.floor(progress * paragraphs.length);
      setVisibleIndex(newIndex);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [paragraphs.length]);

  return (
    <section className="cm-admk-wrapper" ref={sectionRef}>
      <div className="cm-admk-container">

        {/* LEFT FIXED CONTENT */}
        <div className="cm-admk-left">
          <div className="cm-admk-left-border"></div>
          <p className="cm-admk-subtitle">{t("admk_history_subtitle")}</p>
          <h2 className="cm-admk-title-red">{t("admk_title_red")}</h2>
          <h2 className="cm-admk-title-black">{t("admk_title_black")}</h2>
        </div>

        {/* RIGHT CONTENT */}
        <div className="cm-admk-right">
          {paragraphs.map((text, index) => (
            <p
              key={index}
              className={`cm-admk-para ${index <= visibleIndex ? "visible" : ""}`}
            >
              {text}
            </p>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AboutADMKSection;
